import { Box, Text } from '@chakra-ui/react';
import OrderBookType from 'enums/shared/orderBookType';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import OrderBookTableRow from './OrderBookTableRow';

interface Props {
  items: OrderBookItem[];
  type: OrderBookType;
}

const OrderBookTable: FC<Props> = ({ items, type }) => {
  const totalOrders = useMemo(
    () => items.reduce((val, item) => val + item.count, 0),
    []
  );

  const { t } = useTranslation();

  const description =
    type === OrderBookType.Buy ? t('orderTableBuy') : t('orderTableSell');

  return (
    <Box flex="1">
      <Text textAlign={type === OrderBookType.Buy ? 'left' : 'right'}>{description}</Text>
      {items.map((item, key) => {
        return (
          <OrderBookTableRow
            key={key}
            item={item}
            type={type}
            filledPercent={item.count / totalOrders}
          />
        );
      })}
    </Box>
  );
};

export default OrderBookTable;
